'use strict';

(function() {
	angular
		.module('onboarding.common')
		.directive('cobBlur',
			function() {
				return function(scope, element, attrs) {
					element.bind('blur',
						function(event) {
							scope.$eval(attrs.cobBlur, { 'event': event });
						});
				};
			});
})();
